import { render, staticRenderFns } from "./ComplaintSeverityChart.vue?vue&type=template&id=69041c02&"
import script from "./ComplaintSeverityChart.vue?vue&type=script&lang=ts&"
export * from "./ComplaintSeverityChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports